import React from 'react';
import { useInstance } from '@meraki-internal/react-dependency-injection';
import { useSubscription } from '@meraki-internal/state';
import { CareMapState } from '../caremap/CareMapState';
import { ActiveCareMapProviderV2 } from '../ActiveCareMapProvider';
import { OnboardingModel } from './OnboardingModel';
import { OnboardingCard } from './OnboardingCard';
import { Section } from '../caregiver/Section';

export const Onboarding: React.FC<{careMapId?: string}> = ({ careMapId }) => {

    const careMapState = useInstance(CareMapState);
    useSubscription(() => careMapState);

    const activeCareMapId = careMapId || careMapState.getMostRecentCaremap()?.careMapId;

    return (
        <ActiveCareMapProviderV2 careMapId={activeCareMapId}>
            <OnboardingCards />
        </ActiveCareMapProviderV2>
    );
};

const OnboardingCards: React.FC = () => {

    const model = useInstance(OnboardingModel);
    useSubscription(() => model);

    const tasks = model.getTasks();

    if (!tasks.length) {
        return null;
    }

    // expand first card with incomplete tasks
    const expandIndex = tasks.findIndex(c => c.steps.some(t => t.ready && !t.completed));

    return (
        <Section data-id="onboarding" title="Build Your Innerhive">
            {tasks.map((task, i) => (
                <OnboardingCard key={task.heading} task={task} expanded={i === expandIndex} />
            ))}
        </Section>
    );
};
